import React from 'react';
import { useSearchQuestion, useSearchResults } from '@context/DataContext';
export const NoResults = () => {
  const { resultsSummary: summary, isLoading } = useSearchResults();
  const { query: searchQuery } = useSearchQuestion();
  const maybeFor =
    searchQuery !== '!showall' ? (
      <>
        for <strong className="base-cards__card--highlight">{searchQuery.trim()}</strong>
      </>
    ) : (
      <></>
    );
  return !summary.totalMatching && !isLoading ? (
    <article role="alert" className="base-cards__list">
      <div className="base-cards__card base-cards__card--nohover">
        <div className="base-cards__body">
          Your search {maybeFor} did not return any results<span id="currentTab">.</span>
        </div>
      </div>
    </article>
  ) : (
    <></>
  );
};
export default NoResults;
